import { HttpClient } from '@angular/common/http';
import {
  AfterContentInit,
  AfterViewInit,
  Component,
  OnInit,
} from '@angular/core';
import { ApiUrls } from '../../api-urls';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
  selector: 'app-todo-modal',
  templateUrl: './todo-modal.component.html',
  styleUrls: ['./todo-modal.component.scss'],
})
export class TodoModalComponent implements OnInit, AfterViewInit {
  todoData: any;
  years: any;
  constructor(
    private http: HttpClient,
    private modalService: NgbModal,
    private router: Router,
  ) {}

  backDrop: any;
  ngOnInit(): void {
    this.getTodoList();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.backDrop = document.querySelector('.modal.todoListModal'); // Get modal backdrop
      if (this.backDrop) {
        this.backDrop.addEventListener('click', (event) =>
          this.modalDismiss(event),
        );
      }
    }, 50);
  }

  async getTodoList() {
    let res: any = await this.http.get(ApiUrls.todo_dashboard).toPromise();
    if (res?.message?.success) {
      this.todoData = res?.message?.todo_data;
    }
  }
  modalDismiss(event?: any) {
    if (event) {
      event.stopPropagation();

      const modalContent = document.querySelector('.modal-dialog'); // Get modal content
      if (
        event.target !== this.backDrop &&
        event.target.classList[0] != 'ri-close-fill'
      ) {
        console.log('Clicked inside modal content, ignoring close.');
        return; // ✅ Prevent closing when clicking inside modal
      }
      modalContent.classList.add('Close-dialog');
    }

    this.modalService?.dismissAll();
    document.removeEventListener('click', this.backDrop);
  }

  naviagteTo(name: any) {
    // reject_but_not_cancelled
    // no_tin_ar
    let dates = this.getMonthDateRange(
      new Date().getFullYear(),
      this.todoData?.previous_month,
    );

    let queryParams: any = { search: { invoiceTypes: { filters: {} } } };
    switch (name) {
      case 'b2b_pending':
        queryParams.search.invoiceType = 'B2B';
        queryParams.search.irn = 'Pending';
        break;
      case 'b2g_pending':
        queryParams.search.invoiceType = 'B2G';
        queryParams.search.irn = 'Pending';
        break;
      case 'b2c_ttx_pending':
        queryParams.search.b2c_ttx = 'Yes';
        queryParams.search.is_tourism_tax = 1;
        queryParams.search.irn = 'Pending';
        queryParams.active = 9;
        break;
      case 'has_high_value_transaction':
        queryParams.search.has_high_value_transaction = 'Yes';
        // queryParams.search.is_tourism_tax = '0';

        break;

      // case 'has_high_value_transaction':
      //   queryParams.search.invoiceTypes.filters.has_high_value_transaction = 'Yes';
      //   queryParams.search.is_tourism_tax = '0';
      //   // queryParams.search.filterBy = 'This Month';
      //   // queryParams.search.invoiceType = 'B2C';
      //   break;
      case 'total_error':
        queryParams.search.irn = 'Error';
        break;
      case 'missing_loc':
        queryParams.search.missing_location = 'Yes';
        break;
      case 'no_tin_ar':
        queryParams.search.noTin = true;
        break;
    }
    if (name !== 'no_tin_ar') {
      if (name == 'e-invoice') {
        queryParams.tab_name = 'by_invoice';
        queryParams.search = JSON.stringify({
          filterBy: 'Last 6 Months',
          fromComp: 'todo',
        });

        this.router
          .navigate(['/home/e-invoice-requests'], {
            queryParams: {
              ...queryParams,
              itemsPerPage: 20,
              currentPage: 1,
              totalCount: 0,
              start: 0,
            },
          })
          .then(() => {
            this.modalService?.dismissAll();
          });
        return;
      }
      if (name == 'ttx_missing_state_or_country') {
        queryParams.search.filterBy = 'Custom';
        queryParams.search.filterDate = dates;
        queryParams.active = 9;
        queryParams.search = JSON.stringify(queryParams.search);

        this.router
          .navigate(['/home/country-mismatch'], { queryParams: queryParams })
          .then(() => {
            this.modalService?.dismissAll();
          });
        return;
      }
      queryParams.search.filterBy = 'Custom';
      queryParams.search.filterDate = dates;
      // }
      if (name == 'has_high_value_transaction') {
        queryParams.active = 6;
      } else queryParams.active = 9;
      queryParams.search = JSON.stringify(queryParams.search);

      this.router
        .navigate(['/home/invoices'], { queryParams: queryParams })
        .then(() => {
          this.modalService?.dismissAll();
        });
      return;
    }

    queryParams.search.ar_type = '';
    queryParams.search = JSON.stringify(queryParams.search);

    this.router
      .navigate(['/home/ar-invoices'], { queryParams: queryParams })
      .then(() => {
        this.modalService?.dismissAll();
      });
  }

  getMonthDateRange(year: number, monthName: string) {
    // Convert month name to a 0-based month index
    const monthIndex = new Date(`${monthName} 1, ${year}`).getMonth();

    // Get the first day of the month
    const fromDate = new Date(year, monthIndex, 1);

    // Get the last day of the month
    const toDate = new Date(year, monthIndex + 1, 0); // This correctly gets the last date

    // Format the dates to ISO string
    const filterDates = [fromDate.toISOString(), toDate.toISOString()];

    return filterDates;
  }

  ngOnDestroy() {
    console.log(this.backDrop);
    this.modalDismiss(null);
    document.removeEventListener('click', this.backDrop);
  }
}
